import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTiposFortalezaService,
  getTiposSubFraseService,
  getFrasesService,
  createFraseService,
  updateFraseService,
  toggleFraseActiveService,
  getFrasesSelectorService,
  getSubFrasesService,
  createSubFraseService,
  updateSubFraseService,
  toggleSubFraseActiveService,
  getOpcionesRespuestaService,
  updateOpcionRespuestaService,
} from "../../services/preguntasTalento/preguntasTalento.service";

const msg = (error, fallback) =>
  error.response?.data?.message ||
  error.response?.data?.detail ||
  fallback;

// TIPOS DE FORTALEZA -----------------------------------------
export const fetchTiposFortalezaThunk = createAsyncThunk(
  "preguntasTalento/fetchTiposFortaleza",
  async (_, { rejectWithValue }) => {
    try { return await getTiposFortalezaService(); }
    catch (e) { return rejectWithValue(msg(e, "Error al cargar tipos de fortaleza")); }
  }
);

// TIPOS DE SUB-FRASE (fortaleza / aplicación) ----------------
export const fetchTiposSubFraseThunk = createAsyncThunk(
  "preguntasTalento/fetchTiposSubFrase",
  async (_, { rejectWithValue }) => {
    try { return await getTiposSubFraseService(); }
    catch (e) { return rejectWithValue(msg(e, "Error al cargar tipos de sub-frase")); }
  }
);

// FRASES -----------------------------------------------------
export const fetchFrasesThunk = createAsyncThunk(
  "preguntasTalento/fetchFrases",
  async (params, { rejectWithValue }) => {
    try { return await getFrasesService(params); }
    catch (e) { return rejectWithValue(msg(e, "Error al listar frases")); }
  }
);

export const createFraseThunk = createAsyncThunk(
  "preguntasTalento/createFrase",
  async (payload, { rejectWithValue }) => {
    try { return await createFraseService(payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al crear frase")); }
  }
);

export const updateFraseThunk = createAsyncThunk(
  "preguntasTalento/updateFrase",
  async ({ id, payload }, { rejectWithValue }) => {
    try { return await updateFraseService(id, payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al actualizar frase")); }
  }
);

export const toggleFraseActiveThunk = createAsyncThunk(
  "preguntasTalento/toggleFrase",
  async (id, { rejectWithValue }) => {
    try { return await toggleFraseActiveService(id); }
    catch (e) { return rejectWithValue(msg(e, "Error al cambiar estado")); }
  }
);

export const fetchFrasesSelectorThunk = createAsyncThunk(
  "preguntasTalento/fetchFrasesSelector",
  async (params, { rejectWithValue }) => {
    try { return await getFrasesSelectorService(params); }
    catch (e) { return rejectWithValue(msg(e, "Error al cargar selector")); }
  }
);

// SUB-FRASES -------------------------------------------------
export const fetchSubFrasesThunk = createAsyncThunk(
  "preguntasTalento/fetchSubFrases",
  async (params, { rejectWithValue }) => {
    try { return await getSubFrasesService(params); }
    catch (e) { return rejectWithValue(msg(e, "Error al listar sub-frases")); }
  }
);

export const createSubFraseThunk = createAsyncThunk(
  "preguntasTalento/createSubFrase",
  async (payload, { rejectWithValue }) => {
    try { return await createSubFraseService(payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al crear sub-frase")); }
  }
);

export const updateSubFraseThunk = createAsyncThunk(
  "preguntasTalento/updateSubFrase",
  async ({ id, payload }, { rejectWithValue }) => {
    try { return await updateSubFraseService(id, payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al actualizar sub-frase")); }
  }
);

export const toggleSubFraseActiveThunk = createAsyncThunk(
  "preguntasTalento/toggleSubFrase",
  async (id, { rejectWithValue }) => {
    try { return await toggleSubFraseActiveService(id); }
    catch (e) { return rejectWithValue(msg(e, "Error al cambiar estado")); }
  }
);

// OPCIONES SÍ/NO ---------------------------------------------
export const fetchOpcionesRespuestaThunk = createAsyncThunk(
  "preguntasTalento/fetchOpciones",
  async (_, { rejectWithValue }) => {
    try { return await getOpcionesRespuestaService(); }
    catch (e) { return rejectWithValue(msg(e, "Error al cargar opciones")); }
  }
);

export const updateOpcionRespuestaThunk = createAsyncThunk(
  "preguntasTalento/updateOpcion",
  async ({ id, payload }, { rejectWithValue }) => {
    try { return await updateOpcionRespuestaService(id, payload); }
    catch (e) { return rejectWithValue(msg(e, "Error al actualizar opción")); }
  }
);
